import { ISearchFilterFirearmRequest } from 'models/searchFilter';
import { clearObject } from 'helpers/objects';
import { ISearchFormValues } from 'pages/Firearms/RegisteredFirearmsSearchForm';

export const mapValuesToFirearmPresetRequest = (
  data: ISearchFormValues,
): ISearchFilterFirearmRequest => {
  const values: ISearchFilterFirearmRequest = {
    fireCycleId: data.fireCycleId,
    statesUniqueIds: data.statesUniqueIds,
    legalityUniqueId: data.legalityUniqueId,
    makesUniqueIds: data.makesUniqueIds,
    modelsUniqueIds: data.modelsUniqueIds,
    manufacturersUniqueIds: data.manufacturersUniqueIds,
    exhibitNumber: data.exhibitNumber,
    calibersUniqueIds: data.calibersUniqueIds,
    marking: data.marking,
    productCode: data.productCode,
    actionsUniqueIds: data.actionsUniqueIds,
    typesUniqueIds: data.typesUniqueIds,
    ownerUniqueId: data.ownerUniqueId,
    keeperUniqueId: data.keeperUniqueId,
    serialNumber: data.serialNumber,
  };
  return clearObject(values);
};

export const permittedFirearmFilterFields = [
  'fireCycleId',
  'statesUniqueIds',
  'legalityUniqueId',
  'makesUniqueIds',
  'modelsUniqueIds',
  'manufacturersUniqueIds',
  'marking',
  'calibersUniqueIds',
  'productCode',
  'actionsUniqueIds',
  'typesUniqueIds',
  'ownerName',
  'keeperName',
  'serialNumber',
  'exhibitNumber',
];

const excludedFields = ['ownerUniqueId', 'keeperUniqueId'];

export const excludeOwnerAndKeeperIds = (values: { key: string; value: string }[]) =>
  values.filter((item) => !excludedFields.includes(item.key));
